import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { useSelector } from 'react-redux';
import { Data } from 'signup-constants/signupData/Data';
import { LayoutType } from 'signup-components/types';
import { useSignupData } from '../signup-data/useSignupData';
import { getGuessedDataBiden, getGuessedDataBreeze } from '../store/guessed-prefill/selectors';
import { useSearchAndPrefillExperiment } from '../hooks/useSearchAndPrefillExperiment';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { jsx as _jsx } from "react/jsx-runtime";
export const GuessedPrefillHelperText = ({
  dataKey
}) => {
  const {
    data
  } = useSignupData(dataKey);
  const guessedDataBiden = useSelector(getGuessedDataBiden(dataKey));
  const guessedDataBreeze = useSelector(getGuessedDataBreeze(dataKey));
  const {
    searchAndPrefillHelperText,
    shouldUseBreezeCompanyInfo
  } = useSearchAndPrefillExperiment();
  const {
    layoutType
  } = useLayoutTemplate();
  const isSidePanel = layoutType === LayoutType.SidePanel;
  if (isSidePanel) {
    return null;
  }
  if (!guessedDataBiden && !guessedDataBreeze) {
    return null;
  }
  let isGuessedDataInInput = guessedDataBiden === data;
  if (shouldUseBreezeCompanyInfo && dataKey === Data.CompanyName) {
    isGuessedDataInInput = guessedDataBreeze === data;
  }
  if (isGuessedDataInInput && isValidI18nKey(searchAndPrefillHelperText)) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: searchAndPrefillHelperText
    });
  }
  return null;
};